export function setTipoMovilidad(departamento, municipio) {
    if (departamento !== '2') {
        return '1';
    }else if (departamento === '2') {
        if (municipio !== '12') {
            return '2';
        } else if (municipio === '12') {
            return '3';
        }
    }
}